// extracted by mini-css-extract-plugin
module.exports = {"form":"form-common__form___3jNLS","margin-left":"form-common__margin-left___2nBMx","flex-row":"form-common__flex-row___2xUY2"};